import {
    ACTION_TO_SET_FAVORITE_GROUP,
    ARE_YOU_SURE,
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_COMMENT,
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_SHORT_MESSAGE,
    ENTER_LOGIN_OF_FRIEND_WHO_YOU_WANT_TO_INVITE_SEPARATE_BY_COMMA_IF_THEY_ARE_MORE,
    GROUP_group_IS_ADDED_TO_FAVORITES,
    GROUP_group_IS_REMOVED_FROM_FAVORITES,
    GROUP_INFO_POSTS_OF_group_ARE_HIDDEN_IN_YOUR_FEED,
    GROUP_notifications_DISABLED,
    GROUP_notifications_ENABLED,
    GROUP_POST_PINNED,
    GROUP_POST_UNPINNED,
    NOTIFICATIONS,
    YOU_HAVE_BECOME_MEMBER_OF_GROUP_name,
    YOU_HAVE_LEFT_GROUP_name,
} from 'mk/autogenerated/translations/GroupShared.sagas.137c615ff296d286269ba3f74f7629b7'
import { isAuthenticated, isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import assetUrl from 'mk/common/assetUrl';
import { photoUrl } from 'mk/photo/photoUrl';
import {
    blogs_api_delete_comment_url,
    blogs_api_group_ask_to_join_url,
    blogs_api_group_invite_users_url,
    blogs_api_group_join_url,
    blogs_api_group_leave_url,
    blogs_api_group_post_delete_url,
    blogs_api_group_post_pin_url,
    blogs_api_group_post_unpin_url,
    blogs_api_group_set_as_favorite_url,
    blogs_api_group_set_hide_posts_from_feed_url,
    wall_api_set_follow_url,
} from 'mk/urls/functions';
import { CommentDeleteNormalizedResponse } from 'mk2/apps/blogs/containers/Comments/Comments.actions';
import {
    BlogPostEntity,
    BlogPostSchema,
    CommentEntity,
    CommentSchema,
    GroupEntity,
    GroupMemberEntity,
    GroupMemberSchema,
    GroupSchema,
} from 'mk2/apps/blogs/schemas';
import { getModelAndId } from 'mk2/apps/blogs/utils';
import { State as GroupSharedState } from 'mk2/apps/groups/containers/GroupShared/GroupShared.reducers';
import { getGroupSharedState } from 'mk2/apps/groups/containers/GroupShared/GroupShared.selectors';
import { groupsGroupUrl } from 'mk2/apps/groups/urls';
import { wallUrl } from 'mk2/apps/wall/urls';
import Interpolate from 'mk2/components/Interpolate';
import Link from 'mk2/components/Link';
import { deletionCleanup, deletionShowForm, deletionStopSubmit } from 'mk2/containers/Deletion/Deletion.actions';
import { DeletionTargetType } from 'mk2/containers/Deletion/Deletion.schemas';
import { DeletionFormData } from 'mk2/containers/Deletion/DeletionForm';
import { pageHeaderAddFeedMenuItem, pageHeaderRemoveFeedMenuItem } from 'mk2/containers/PageHeader/PageHeader.action';
import { handleXHRPostErrorSaga, normalizeError, XHRAction, XHRClient, XHRPostError } from 'mk2/helpers/api';
import { showSuccessToast } from 'mk2/helpers/toasts';
import { url } from 'mk2/helpers/urls';
import { getLogger } from 'mk2/logger';
import { AppState, getRequestUser } from 'mk2/reducers';
import { checkIfUserIsLoggedIn } from 'mk2/sagas/auth';
import { UserEntity } from 'mk2/schemas';
import { getDenormalizedEntity } from 'mk2/selectors';
import { pushInPWASaga, redirectInPWASaga } from 'mk2/services/browserHistory';
import { normalize } from 'normalizr';
import React from 'react';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import {
    GROUP_SHARED_DELETE_GROUP_POST,
    GROUP_SHARED_DELETE_GROUP_POST_COMMENT,
    GROUP_SHARED_DELETE_GROUP_POST_COMMENT_INIT,
    GROUP_SHARED_DELETE_GROUP_POST_INIT,
    GROUP_SHARED_HIDE_POSTS_OF_A_GROUP_IN_FEED,
    GROUP_SHARED_INVITE_USER,
    GROUP_SHARED_JOIN_GROUP,
    GROUP_SHARED_LEAVE_GROUP,
    GROUP_SHARED_POST_STICKY,
    GROUP_SHARED_SET_GROUP_AS_FAVORITE,
    GROUP_SHARED_SUBSCRIBE_GROUP,
    groupSharedAskForMembershipApi,
    groupSharedDeleteGroupPost,
    GroupSharedDeleteGroupPostAction,
    groupSharedDeleteGroupPostApi,
    groupSharedDeleteGroupPostComment,
    GroupSharedDeleteGroupPostCommentAction,
    groupSharedDeleteGroupPostCommentApi,
    GroupSharedDeleteGroupPostInitAction,
    GroupSharedDeleteGroupPostNormalizedResponse,
    GroupSharedHidePostsOfAGroupInFeedAction,
    groupSharedHidePostsOfAGroupInFeedApi,
    GroupSharedInviteUserAction,
    groupSharedInviteUserApi,
    GroupSharedJoinGroupAction,
    groupSharedJoinGroupApi,
    GroupSharedLeaveGroupAction,
    groupSharedLeaveGroupApi,
    GroupSharedPostStickyAction,
    groupSharedPostStickyApi,
    GroupSharedSetGroupAsFavoriteAction,
    groupSharedSetGroupAsFavoriteApi,
    GroupSharedSubscribeGroupAction,
    groupSharedSubscribeGroupApi,
} from './GroupShared.actions';

const logger = getLogger('groups/GroupShared.sagas');

interface AskForMembershipApiResponse {
    body: {};
}

function* askForMembership(groupId, xhr) {
    const requestUser: UserEntity = yield select(getRequestUser);
    if (!isAuthenticated(requestUser)) {
        return;
    }
    yield put(groupSharedAskForMembershipApi.request(groupId));

    try {
        const response: AskForMembershipApiResponse = yield call(
            () => xhr.post(blogs_api_group_ask_to_join_url(groupId), {}),
        );

        const normalizedResponse = normalize(response.body, {});
        yield put(groupSharedAskForMembershipApi.success(groupId, normalizedResponse));
    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(groupSharedAskForMembershipApi.failure(groupId, error));
    }
}

interface JoinGroupApiResponse {
    body: {
        group: GroupEntity;
        memberships: number[],
    };
}

function* joinGroup(group: GroupEntity, origin: string, xhr: XHRClient) {
    yield put(groupSharedJoinGroupApi.request(group.id));

    // Join the group
    try {
        const response: JoinGroupApiResponse = yield call(
            () => xhr.post(blogs_api_group_join_url(group.id), {
                origin,
            }),
        );

        const normalizedResponse = normalize(response.body, {
            group: GroupSchema,
        });

        yield put(groupSharedJoinGroupApi.success(
            group.id,
            response.body.memberships,
            normalizedResponse,
        ));

        const icon = group.coverPhoto
            ? photoUrl(group.coverPhoto, 'c50x50')
            : assetUrl + 'img/photoblog/groups/icon-feed-menu-group.gif';

        yield put(pageHeaderAddFeedMenuItem(
            group.locked ? 'my-private-groups' : 'my-public-groups',
            `group-${group.id}`,
            group.name,
            icon,
            url(groupsGroupUrl, { groupId: group.id }),
        ));

        yield showSuccessToast(
            <Interpolate
                i18nKey={YOU_HAVE_BECOME_MEMBER_OF_GROUP_name}
                name={<strong>{group.name}</strong>}
            />,
        );

        yield pushInPWASaga(url(groupsGroupUrl, { groupId: group.id }));
    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(groupSharedJoinGroupApi.failure(group.id, normalizeError(error)));
    }
}

function* askOrJoinGroup({ groupId, origin, xhr }: GroupSharedJoinGroupAction & XHRAction) {
    const group: GroupEntity = yield select(
        (state: AppState) => getDenormalizedEntity<GroupEntity>(state, GroupSchema, groupId),
    );

    if (group.locked) {
        yield* askForMembership(groupId, xhr);
    } else {
        yield* joinGroup(group, origin, xhr);
    }
}

interface LeaveGroupApiResponse {
    body: {
        group: GroupEntity;
        memberships: number[],
    };
}

function* leaveGroup({ groupId, onSuccess, redirect, xhr }: GroupSharedLeaveGroupAction & XHRAction) {
    const confirmation = confirm(ARE_YOU_SURE);
    if (!confirmation) {
        return;
    }

    const group: GroupEntity = yield select(
        (state: AppState) => getDenormalizedEntity<GroupEntity>(state, GroupSchema, groupId),
    );

    yield put(groupSharedLeaveGroupApi.request(groupId));

    try {
        const response: LeaveGroupApiResponse = yield call(
            () => xhr.post(blogs_api_group_leave_url(groupId)),
        );

        const normalizedResponse = normalize(response.body, {
            group: GroupSchema,
        });

        yield put(groupSharedLeaveGroupApi.success(
            groupId,
            response.body.memberships,
            normalizedResponse,
        ));

        yield put(pageHeaderRemoveFeedMenuItem(
            group.locked ? 'my-private-groups' : 'my-public-groups',
            `group-${group.id}`,
        ));
        const groupSharedState: GroupSharedState = yield select(getGroupSharedState);
        if (groupSharedState.favorites.includes(group.id)) {
            yield put(pageHeaderRemoveFeedMenuItem('my-favorites', `group-${group.id}`));
        }

        yield showSuccessToast(
            <Interpolate
                i18nKey={YOU_HAVE_LEFT_GROUP_name}
                name={<strong>{group.name}</strong>}
            />,
        );

        if (redirect) {
            yield pushInPWASaga(url(groupsGroupUrl, { groupId }));
        }

        if (onSuccess) {
            onSuccess();
        }

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(groupSharedLeaveGroupApi.failure(groupId, normalizeError(error)));
    }
}

interface HidePostsOfAGroupInFeedApiResponse {
    body: {
        usersMember: GroupMemberEntity;
    };
}

function* hidePostsOfAGroupInFeed({ groupId, onSuccess, xhr }: GroupSharedHidePostsOfAGroupInFeedAction & XHRAction) {
    const confirmation = confirm(ARE_YOU_SURE);
    if (!confirmation) {
        return;
    }

    yield put(groupSharedHidePostsOfAGroupInFeedApi.request(groupId));

    try {
        const group: GroupEntity = yield select(
            (state: AppState) => getDenormalizedEntity<GroupEntity>(state, GroupSchema, groupId),
        );

        const response: HidePostsOfAGroupInFeedApiResponse = yield call(
            () => xhr.put(blogs_api_group_set_hide_posts_from_feed_url(groupId), {
                hideGroupInFeed: true,
            }),
        );

        const normalizedResponse = normalize({
            usersMember: response.body.usersMember,
        }, {
            usersMember: GroupMemberSchema,
        });

        yield put(groupSharedHidePostsOfAGroupInFeedApi.success(groupId, normalizedResponse));

        yield showSuccessToast(
            <Interpolate
                i18nKey={GROUP_INFO_POSTS_OF_group_ARE_HIDDEN_IN_YOUR_FEED}
                group={<strong>{group.name}</strong>}
            />,
        );

        if (onSuccess) {
            onSuccess();
        }

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(groupSharedHidePostsOfAGroupInFeedApi.failure(groupId, normalizeError(error)));
    }
}

interface SubscribeGroupApiResponse {
    body: {
        follow: boolean;
    };
}

function* subscribeGroup({ groupId, subscribe, username, xhr }: GroupSharedSubscribeGroupAction & XHRAction) {
    yield put(groupSharedSubscribeGroupApi.request(groupId));
    try {
        const response: SubscribeGroupApiResponse = yield call(
            () => xhr.post(wall_api_set_follow_url(username), {
                channelName: 'group',
                channelId: groupId,
                follow: subscribe,
            }),
        );

        yield put(groupSharedSubscribeGroupApi.success(
            groupId,
            response.body.follow,
        ));

        yield showSuccessToast(
            <Interpolate
                i18nKey={response.body.follow ? GROUP_notifications_ENABLED : GROUP_notifications_DISABLED}
                notifications={<Link to={wallUrl}>{NOTIFICATIONS.toLowerCase()}</Link>}
            />,
        );

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(groupSharedSubscribeGroupApi.failure(groupId, normalizeError(error)));
    }
}

interface SetGroupAsFavoriteApiResponse {
    body: {
        isFavorite: boolean;
    };
}

function* setGroupAsFavorite({ groupId, userId, setAsFavorite, xhr }: GroupSharedSetGroupAsFavoriteAction & XHRAction) {
    if (!(yield call(checkIfUserIsLoggedIn, ACTION_TO_SET_FAVORITE_GROUP))) {
        return;
    }

    yield put(groupSharedSetGroupAsFavoriteApi.request(groupId, userId, setAsFavorite));
    try {
        const group: GroupEntity = yield select(
            (state: AppState) => getDenormalizedEntity<GroupEntity>(state, GroupSchema, groupId),
        );

        const response: SetGroupAsFavoriteApiResponse = yield call(
            () => xhr.post(blogs_api_group_set_as_favorite_url(groupId), {
                userId,
                setAsFavorite,
            }),
        );

        yield put(groupSharedSetGroupAsFavoriteApi.success(groupId, userId, setAsFavorite));

        if (setAsFavorite) {
            const icon = group.coverPhoto
                ? photoUrl(group.coverPhoto, 'c50x50')
                : assetUrl + 'img/photoblog/groups/icon-feed-menu-group.gif';

            yield put(pageHeaderAddFeedMenuItem(
                'my-favorites',
                `group-${groupId}`,
                group.name,
                icon,
                url(groupsGroupUrl, { groupId }),
            ));
        } else {
            yield put(pageHeaderRemoveFeedMenuItem(
                'my-favorites',
                `group-${group.id}`,
            ));
        }

        yield showSuccessToast(
            <Interpolate
                i18nKey={response.body.isFavorite ? GROUP_group_IS_ADDED_TO_FAVORITES : GROUP_group_IS_REMOVED_FROM_FAVORITES}
                group={<strong>{group.name}</strong>}
            />,
        );

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(groupSharedSetGroupAsFavoriteApi.failure(groupId, userId, setAsFavorite, normalizeError(error)));
    }
}

function* deletePostInit({ postId, redirectUrl }: GroupSharedDeleteGroupPostInitAction) {
    const requestUser = yield select(getRequestUser);
    const post: BlogPostEntity = yield select((state: AppState) => getDenormalizedEntity<BlogPostEntity>(state, BlogPostSchema, postId));
    const isAuthor = isAuthenticatedAs(requestUser, post.author);

    if (isAuthor) {
        if (!window.confirm(ARE_YOU_SURE_YOU_WANT_TO_DELETE_SHORT_MESSAGE)) {
            return;
        }
        yield put(groupSharedDeleteGroupPost(postId, redirectUrl));
    } else {
        yield put(deletionShowForm(
            DeletionTargetType.PhotoblogPost,
            postId,
            (deletion: DeletionFormData) => groupSharedDeleteGroupPost(postId, redirectUrl, deletion.deletionComment),
        ));
    }
}

interface DeletePostApiResponse {
    body: {
        message: string;
        post: BlogPostEntity;
    };
}

function* deletePost({ comment, postId, redirectUrl, xhr }: GroupSharedDeleteGroupPostAction & XHRAction) {
    const requestUser = yield select(getRequestUser);
    const post: BlogPostEntity = yield select((state: AppState) => getDenormalizedEntity<BlogPostEntity>(state, BlogPostSchema, postId));
    const isAuthor = isAuthenticatedAs(requestUser, post.author);

    yield put(groupSharedDeleteGroupPostApi.request(postId));

    try {
        const response: DeletePostApiResponse = yield call(
            () => xhr.post(blogs_api_group_post_delete_url(postId), isAuthor ? {} : { comment }),
        );

        const normalizedResponse: GroupSharedDeleteGroupPostNormalizedResponse = normalize({
            post: response.body.post,
        }, {
            post: BlogPostSchema,
        });

        yield put(deletionCleanup(DeletionTargetType.PhotoblogPost, postId));

        yield put(groupSharedDeleteGroupPostApi.success(
            postId,
            normalizedResponse,
        ));

        yield showSuccessToast(response.body.message);

        if (redirectUrl) {
            yield redirectInPWASaga(redirectUrl);
        }

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(deletionStopSubmit(DeletionTargetType.PhotoblogPost, postId));
        yield put(groupSharedDeleteGroupPostApi.failure(postId, normalizeError(error)));
    }
}

function* deleteCommentInit({ commentId, key }: GroupSharedDeleteGroupPostCommentAction) {
    const requestUser = yield select(getRequestUser);
    const comment: CommentEntity = yield select((state: AppState) => getDenormalizedEntity<CommentEntity>(state, CommentSchema, commentId));
    const isCommentAuthor = isAuthenticatedAs(requestUser, comment.authorUser);

    if (isCommentAuthor) {
        if (!window.confirm(ARE_YOU_SURE_YOU_WANT_TO_DELETE_COMMENT)) {
            return;
        }
        yield put(groupSharedDeleteGroupPostComment(commentId, key));
    } else {
        yield put(deletionShowForm(
            DeletionTargetType.PhotoblogComment,
            commentId,
            (deletion: DeletionFormData) => groupSharedDeleteGroupPostComment(commentId, key, deletion.deletionComment),
        ));
    }
}

interface DeletePostCommentApiResponse {
    body: {
        comment: CommentEntity;
    };
}

function* deleteComment({ commentId, deletionComment, key, xhr }: GroupSharedDeleteGroupPostCommentAction & XHRAction) {
    const model = getModelAndId(key)[0];
    const requestUser = yield select(getRequestUser);
    const comment: CommentEntity = yield select((state: AppState) => getDenormalizedEntity<CommentEntity>(state, CommentSchema, commentId));
    const isCommentAuthor = isAuthenticatedAs(requestUser, comment.authorUser);

    yield put(groupSharedDeleteGroupPostCommentApi.request(commentId));

    try {
        const response: DeletePostCommentApiResponse = yield call(
            () => xhr.post(
                blogs_api_delete_comment_url(model, commentId),
                isCommentAuthor ? {} : { comment: deletionComment },
                ),
        );
        const normalizedResponse: CommentDeleteNormalizedResponse = normalize(response.body.comment, CommentSchema);

        yield put(deletionCleanup(DeletionTargetType.PhotoblogComment, commentId));

        yield put(groupSharedDeleteGroupPostCommentApi.success(commentId, normalizedResponse));

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(deletionStopSubmit(DeletionTargetType.PhotoblogComment, commentId));
        yield put(groupSharedDeleteGroupPostCommentApi.failure(commentId, normalizeError(error)));
    }
}

interface InviteUserApiResponse {
    body: {
        message: string;
    };
}

function* inviteUser({ groupId, xhr }: GroupSharedInviteUserAction & XHRAction) {
    const usersText = prompt(ENTER_LOGIN_OF_FRIEND_WHO_YOU_WANT_TO_INVITE_SEPARATE_BY_COMMA_IF_THEY_ARE_MORE);
    if (!usersText) {
        return;
    }

    const usernames = usersText.split(',').map((username) => username.trim());

    yield put(groupSharedInviteUserApi.request(groupId));

    try {
        const response: InviteUserApiResponse = yield call(
            () => xhr.post(blogs_api_group_invite_users_url(groupId), { usernames }),
        );

        const normalizedResponse = normalize(response.body, {});

        yield put(groupSharedInviteUserApi.success(
            groupId,
            normalizedResponse,
        ));

        yield showSuccessToast(response.body.message);

    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(groupSharedInviteUserApi.failure(groupId, normalizeError(error)));
    }
}

function* postSticky({ postId, sticky, xhr }: GroupSharedPostStickyAction & XHRAction) {
    yield put(groupSharedPostStickyApi.request(postId, sticky));

    try {
        const response = yield call(
            () => xhr.put(
                sticky
                    ? blogs_api_group_post_pin_url(postId)
                    : blogs_api_group_post_unpin_url(postId),
            ),
        );

        const normalizedResponse = normalize(response.body, {post: BlogPostSchema});
        yield put(groupSharedPostStickyApi.success(postId, sticky, normalizedResponse));

        // then display toast
        yield showSuccessToast(sticky ? GROUP_POST_PINNED : GROUP_POST_UNPINNED);
    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(groupSharedPostStickyApi.failure(postId, sticky, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeEvery(GROUP_SHARED_JOIN_GROUP, askOrJoinGroup),
        takeEvery(GROUP_SHARED_LEAVE_GROUP, leaveGroup),
        takeEvery(GROUP_SHARED_HIDE_POSTS_OF_A_GROUP_IN_FEED, hidePostsOfAGroupInFeed),
        takeEvery(GROUP_SHARED_SUBSCRIBE_GROUP, subscribeGroup),
        takeEvery(GROUP_SHARED_SET_GROUP_AS_FAVORITE, setGroupAsFavorite),
        takeEvery(GROUP_SHARED_DELETE_GROUP_POST_INIT, deletePostInit),
        takeEvery(GROUP_SHARED_DELETE_GROUP_POST, deletePost),
        takeEvery(GROUP_SHARED_DELETE_GROUP_POST_COMMENT_INIT, deleteCommentInit),
        takeEvery(GROUP_SHARED_DELETE_GROUP_POST_COMMENT, deleteComment),
        takeEvery(GROUP_SHARED_INVITE_USER, inviteUser),
        takeEvery(GROUP_SHARED_POST_STICKY, postSticky),
    ]);
}
